/**
 * Open Interest API (GET /api/open-interest/query)
 */

import { API_CONFIG } from '@/config/api';
import { apiFetch } from '@/lib/apiFetch';

const BASE = API_CONFIG.OPEN_INTEREST_PATH_PREFIX;

const toOpenInterestExchange = (exchange: string): string => {
  const normalized = exchange.trim().toLowerCase();
  if (normalized === 'okx') return 'OKX';
  if (normalized === 'bybit') return 'Bybit';
  if (normalized === 'binance') return 'Binance';
  return exchange;
};

export interface OpenInterestRecord {
  ts: string;
  exchange: string;
  symbol: string;
  inst_id: string;
  open_interest_usd: number;
  open_interest_token: number;
}

export interface OpenInterestResponse {
  success: boolean;
  count: number;
  data: OpenInterestRecord[];
}

export interface OpenInterestParams {
  exchange: string;
  inst_id: string;
  start_time?: string;
  end_time?: string;
  limit?: number;
}

export async function getOpenInterest(params: OpenInterestParams): Promise<OpenInterestResponse> {
  const q = new URLSearchParams();
  q.set('exchange', toOpenInterestExchange(params.exchange));
  q.set('inst_id', params.inst_id);
  if (params.start_time != null) q.set('start_time', params.start_time);
  if (params.end_time != null) q.set('end_time', params.end_time);
  if (params.limit != null) q.set('limit', String(params.limit));

  const res = await apiFetch(`${BASE}/query?${q.toString()}`, { method: 'GET' });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json() as Promise<OpenInterestResponse>;
}
